import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';

import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import LoginPage from './pages/LoginPage';
import CabinetPage from './pages/CabinetPage';
import CartPage from './pages/CartPage';
import AdminPage from './pages/AdminPage';

import Navbar from './components/Navbar';

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/"        element={<HomePage />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/login"   element={<LoginPage />} />
          <Route path="/cabinet" element={<CabinetPage />} />
          <Route path="/cart"    element={<CartPage />} />
          <Route path="/admin"   element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
